import {
  AnalyticsEventWithControlName,
  ACTIONS,
  SubscriptionType
} from '@uma/react-commons/dist/index';
import {
  getActionAuxParamsSubscriptionsDetails,
  parseType,
  SubscriptionDetailsProps
} from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';

export const ProLiveSupportButtonClicked = {
  ...SubscriptionDetailsProps,
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  controlName: 'ProLiveSupportButton',
  controlDetail: URLS.ProLiveSupport
};

export const MyBillWasNotWhatIExpectedButtonClicked = (
  id: string,
  startDate: string | Date,
  type: SubscriptionType,
  controlDetail: string
): AnalyticsEventWithControlName => ({
  ...SubscriptionDetailsProps,
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  controlName: 'MyBillWasNotWhatIExpectedButton',
  controlDetail,
  screenMode: parseType(type),
  actionAuxParams: getActionAuxParamsSubscriptionsDetails(id, startDate)
});

export const MissingInkButtonClicked = (
  id: string,
  startDate: string | Date,
  controlDetail: string
): AnalyticsEventWithControlName => ({
  ...SubscriptionDetailsProps,
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  controlName: 'ImMissingInkButton',
  controlDetail,
  actionAuxParams: getActionAuxParamsSubscriptionsDetails(id, startDate)
});

export const GetInstantInkSupportButtonClicked = (
  id: string,
  startDate: string | Date
): AnalyticsEventWithControlName => ({
  ...SubscriptionDetailsProps,
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  controlName: 'GetInstantInkSupportButton',
  controlDetail: URLS.GetInstantInkSupport,
  actionAuxParams: getActionAuxParamsSubscriptionsDetails(id, startDate)
});
